import { render } from "./IncomeReport.vue?vue&type=template&id=2a7a01af&scoped=true"
import script from "./IncomeReport.vue?vue&type=script&lang=js"
export * from "./IncomeReport.vue?vue&type=script&lang=js"

import "./IncomeReport.vue?vue&type=style&index=0&id=2a7a01af&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7a01af"]])

export default __exports__